<div class="loading-overlay" *ngIf="show">
  <app-loader></app-loader>
</div>